// 路由路径常量
export const ROUTES = {
  HOME: '/',
  GAMES: '/games',
  BUSINESS: '/business',
  ABOUT: '/about',
};

// 导航菜单配置
export const NAV_ITEMS = [
  {
    path: ROUTES.GAMES,
    label: 'GAMES',
    key: 'games',
  },
  {
    path: ROUTES.BUSINESS,
    label: 'BUSINESS',
    key: 'business',
  },
  {
    path: ROUTES.ABOUT,
    label: 'ABOUT',
    key: 'about',
  },
];

